/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_radar_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Compare two products across speed, price, quality and support.`)
};

const es_radar_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Compara dos productos según velocidad, precio, calidad y soporte.`)
};

const de_radar_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vergleichen Sie zwei Produkte anhand von Geschwindigkeit, Preis, Qualität und Support.`)
};

const nl_radar_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vergelijk twee producten op snelheid, prijs, kwaliteit en ondersteuning.`)
};

const fr_radar_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comparez deux produits selon la vitesse, le prix, la qualité et le support.`)
};

const it_radar_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Confronta due prodotti su velocità, prezzo, qualità e supporto.`)
};

const pt_br2_radar_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Compare dois produtos em velocidade, preço, qualidade e suporte.`)
};

const pt_radar_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Compare dois produtos em velocidade, preço, qualidade e suporte.`)
};

const ja_radar_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`速度、価格、品質、サポートにわたって2つの製品を比較します。`)
};

const zh_radar_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`在速度、价格、质量和支持等方面比较两款产品。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const radar_ex1 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.radar_ex1(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("radar_ex1", locale)
	if (locale === "en") return en_radar_ex1(inputs)
	if (locale === "es") return es_radar_ex1(inputs)
	if (locale === "de") return de_radar_ex1(inputs)
	if (locale === "nl") return nl_radar_ex1(inputs)
	if (locale === "fr") return fr_radar_ex1(inputs)
	if (locale === "it") return it_radar_ex1(inputs)
	if (locale === "pt-BR") return pt_br2_radar_ex1(inputs)
	if (locale === "pt") return pt_radar_ex1(inputs)
	if (locale === "ja") return ja_radar_ex1(inputs)
	return zh_radar_ex1(inputs)
};